import React from 'react';

interface LogoProps {
  className?: string;
  size?: number;
}

const Logo: React.FC<LogoProps> = ({ className = "w-10 h-10", size = 40 }) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Background circle with gradient */}
      <defs>
        <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#00C781" />
          <stop offset="100%" stopColor="#01A982" />
        </linearGradient>
        <linearGradient id="arrowGradient" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="100%" stopColor="#f0f9ff" />
        </linearGradient>
      </defs>
      
      {/* Main background */}
      <rect width="40" height="40" rx="8" fill="url(#logoGradient)" />
      
      {/* API icon (left side - document with lines) */}
      <g transform="translate(6, 8)">
        {/* Document background */}
        <rect x="0" y="0" width="10" height="14" rx="1.5" fill="white" fillOpacity="0.95" />
        
        {/* Document lines representing API */}
        <rect x="2" y="3" width="6" height="1" rx="0.5" fill="#00C781" />
        <rect x="2" y="5.5" width="4" height="1" rx="0.5" fill="#00C781" />
        <rect x="2" y="8" width="5" height="1" rx="0.5" fill="#00C781" />
        <rect x="2" y="10.5" width="3" height="1" rx="0.5" fill="#00C781" />
      </g>
      
      {/* Arrow transformation (center) */}
      <g transform="translate(18, 16)">
        {/* Arrow pointing right */}
        <path 
          d="M0 4 L6 4 M4 2 L6 4 L4 6" 
          stroke="url(#arrowGradient)" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      
      {/* MCP server icon (right side - server/circuit) */}
      <g transform="translate(26, 8)">
        {/* Server/circuit background */}
        <rect x="0" y="0" width="10" height="14" rx="1.5" fill="white" fillOpacity="0.95" />
        
        {/* Circuit/connection patterns */}
        <circle cx="3" cy="4" r="1.5" fill="#01A982" />
        <circle cx="7" cy="4" r="1.5" fill="#01A982" />
        <circle cx="5" cy="8" r="1.5" fill="#01A982" />
        <circle cx="3" cy="11" r="1.5" fill="#01A982" />
        <circle cx="7" cy="11" r="1.5" fill="#01A982" />
        
        {/* Connection lines */}
        <line x1="3" y1="5.5" x2="3" y2="9.5" stroke="#01A982" strokeWidth="1" />
        <line x1="7" y1="5.5" x2="7" y2="9.5" stroke="#01A982" strokeWidth="1" />
        <line x1="4.5" y1="8" x2="5.5" y2="8" stroke="#01A982" strokeWidth="1" />
        <line x1="4.5" y1="4" x2="5.5" y2="4" stroke="#01A982" strokeWidth="1" />
      </g>
      
      {/* Subtle border */}
      <rect width="40" height="40" rx="8" fill="none" stroke="rgba(255,255,255,0.1)" strokeWidth="1" />
    </svg>
  );
};

export default Logo;